import { customerProxy } from '../../../../shared/proxies/customerProxy'
import { buildAxiosInstance } from '../../../../shared/utils/apiUtils'

export async function executeCustomerRetrieve (customerId: string): Promise<void> {
  customerProxy.apiCall.loading = true
  customerProxy.apiCall.error = null
  try {
    const response = await buildAxiosInstance().post('/api/customers/retrieve', { customerId: String(customerId) })
    if (response.data.error) {
      customerProxy.apiCall.error = response.data.error
    } else {
      customerProxy.customer = response.data.data.customer
    }
  } catch (e) {
    if (e instanceof Error) {
      customerProxy.apiCall.error = e.message
    }
  } finally {
    customerProxy.apiCall.loading = false
  }
}

export async function executeParentCustomerRetrieve (parentCustomerId: string): Promise<void> {
  customerProxy.apiCall.loading = true
  customerProxy.apiCall.error = null
  try {
    const response = await buildAxiosInstance().post('/api/customers/retrieve', { customerId: String(parentCustomerId) })
    if (response.data.error) {
      customerProxy.apiCall.error = response.data.error
    } else {
      customerProxy.currentParentCustomer = response.data.data.customer
    }
  } catch (e) {
    if (e instanceof Error) {
      customerProxy.apiCall.error = e.message
    }
  } finally {
    customerProxy.apiCall.loading = false
  }
}

export async function executeChildCustomersRetrieve (customerId: string): Promise<void> {
  customerProxy.apiCall.loading = true
  customerProxy.apiCall.error = null
  try {
    const response = await buildAxiosInstance().post('/api/customers/retrieveChildren', { customerId })
    if (response.data.error) {
      customerProxy.apiCall.error = response.data.error
    } else {
      customerProxy.childCompanies = response.data.data.customers
    }
  } catch (e) {
    if (e instanceof Error) {
      customerProxy.apiCall.error = e.message
    }
  } finally {
    customerProxy.apiCall.loading = false
  }
}
